var sourceDic = {
    '1': '供应链',
    '2': '天子星',
    '3': '采购平台',
    '4': '自主添加',
    '5': '商城',
};
export default sourceDic;
